<template>
  <v-container fluid>
    <v-card id="portal-page" elevation="0" class="px-6 py-12 card">
      <v-row v-for="(row, rowIndex) in portal.layout" :key="rowIndex">
        <!-- TITRE -->
        <v-col cols="12" class="pt-0" v-if="row === 'title'">
          <div class="py-2" :style="{ color: portal.color_main }">
            <strong>{{ portal.title }}</strong>
          </div>
        </v-col>
        <v-col cols="12" class="pb-5 pt-0" v-if="row === 'message'">
          <div class="pa-0" :style="{ color: portal.color_secondary }" v-html="portal.message"></div>
        </v-col>
        <v-col cols="12" class="img-div pa-0 ma-0" v-if="row === 'image'">
          <v-img v-if="portal.banner_image !== null" :src="portal.banner_image"></v-img>
          <v-img v-else
            src="https://images.unsplash.com/photo-1414235077428-338989a2e8c0?ixid=MnwxMjA3fDB8MHxzZWFyY2h8M3x8cmVzdGF1cmFudHxlbnwwfHwwfHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60"></v-img>
        </v-col>
        <v-col cols="12" v-if="row === 'form'">
          <v-row>
            <v-col cols="12" class="">
              <v-card-text><strong>Veuillez renseigner les informations suivantes :</strong></v-card-text>
              <v-text-field v-model="portalData.user" class="mx-4" placeholder="Nom et Prénom"
                hide-details=""></v-text-field>
              <v-text-field v-model="portalData.mail" class="mx-4" placeholder="Email (optionnel)"
                hide-details=""></v-text-field>
              <v-text-field v-model="portalData.phone" class="mx-4" placeholder="N° Mobile"
                hide-details=""></v-text-field>
            </v-col>
            <v-col cols="12" class="py-0 my-0" align="center">
              <v-checkbox v-model="checkbox" label="Je m'inscris au programme de fidelité" hide-details="">
                <template v-slot:label>
                  <div class="tooltip-text">
                    Je m'inscris au
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <a target="_blank" :href="portal.fidelity_program" @click.stop v-on="on">
                          Programme de fidelité
                        </a>
                      </template>
                      Lien vers le programme fidelité
                    </v-tooltip>
                  </div>
                </template>
              </v-checkbox>
            </v-col>
            <v-col cols="12" class="py-0 my-0 pb-4">
              <v-checkbox v-if="portal.switchStatus" v-model="checkbox2"
                label="Covid-19 : Vos coordonnées pour faciliter la recherche des cas contacts." hide-details="">
                <template v-slot:label>
                  <div class="tooltip-text">
                    Covid-19 :
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <a target="_blank" href="" @click.stop v-on="on">
                          Vos coordonnées si cas contacts.
                        </a>
                      </template>
                      Lien vers informations Covid
                    </v-tooltip>
                  </div>
                </template>
              </v-checkbox>
            </v-col>
            <v-col cols="12" class="py-4 my-0">
              <v-btn @click="updateValue(portalData)" hide-details="" x-large
                class="theme-btn shape-rounded filled-purple">Se Connecter</v-btn>
            </v-col>
            <v-col cols="12" class="py-0 my-0">
              <v-checkbox v-model="checkbox3" label="J’accepte la politique de confidentialité" hide-details="">
                <template v-slot:label>
                  <div class="tooltip-text">
                    J'accepte la
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <a target="_blank" :href="portal.address_confidentiality" @click.stop v-on="on">
                          politique de confidentialité
                        </a>
                      </template>
                      Lien vers politique de confidentialité
                    </v-tooltip>
                  </div>
                </template>
              </v-checkbox>
            </v-col>
            <v-col cols="12" class="py-0 my-0">
              <v-checkbox v-model="checkbox4" label="J’accepte les conditions générales de services" hide-details="">
                <template v-slot:label>
                  <div class="tooltip-text">
                    J'accepte les
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <a target="_blank" :href="portal.address_cgu" @click.stop v-on="on">
                          conditions générales de services.
                        </a>
                      </template>
                      Lien vers CGS
                    </v-tooltip>
                  </div>
                </template>
              </v-checkbox>
              <v-card-text><strong class="infos">Vos informations sont sécurisées et resteront
                  confidentielles.</strong></v-card-text>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-card>
  </v-container>
</template>

<script>
export default {
  data: () => {
    return {
      checkbox: false,
      checkbox2: false,
      checkbox3: false,
      checkbox4: false,
    };
  },
  props: {
    portal: {
      type: Object,
      default: () => {
        return {
          title: null,
          messageTop: null,
          fileInputImg: null,
          fileInputImgPreview: null,
          switchStatus: false,
          colorTitle: null,
          colorMessage: null,
          address_cgu: "",
          address_confidentiality: "",
          fidelity_program: "",
          messageBot: "",
          fileInputDoc: null,
          menuUrl: "",
          layout: []
        };
      },
    },
  },
  created() {

    // this.portal = JSON.parse(JSON.stringify(this.portal));
    // console.info("portal", this.portal);
  },
  methods: {
    updateValue(portalData) {
      this.$emit("input", portalData);
      // console.log("portalData", this.portalData);
      return this.portalData;
    },
  },
};
</script>

<style lang="scss">
#portal-page {
  height: 100%;
  overflow: auto;
}

.v-application .primary--text {
  color: #6b5cd7 !important;
  caret-color: #6b5cd7 !important;
}

.img-div {
  background-color: lightgrey;
}

.tooltip-text {
  font-size: 12px;
}

.infos {
  font-size: 10px;
}

.card {
  overflow: auto;
  top: 35px !important;
  margin-right: 10px;
  margin-left: 10px;
  border-bottom-left-radius: 63px !important;
  border-bottom-right-radius: 63px !important;
}
</style>
